import { call, put } from 'redux-saga/effects';
import { types as reviewTypes } from 'reducers/reviews';
import { types as organizationTypes } from 'reducers/organizations';
import * as Api from '@utils/Api';
import qs from 'qs';
import { Type as accountTypes } from '../reducers/Account';
import { fetchBillingInfo } from './billing';
import { generators } from 'stores';

export function* renewSubscriptionAndToggleReview(action) {
  const { pullRequestUUID, enabled, organizationUUID } = action;
  if (!pullRequestUUID || !organizationUUID || enabled === undefined) {
    throw new Error(
      'Missing required parameters for renew subscription and request review'
    );
  }
  const response = yield call(
    Api.post,
    `organizations/${organizationUUID}/subscription`,
    { organizationUuid: organizationUUID }
  );
  const data = response.data;
  if (!response.success) {
    yield put({
      type: organizationTypes.SUBSCRIPTION_CODE_REVIEW_FAILURE,
      error: data ? data.error_message : 'Unknown error',
    });
    return;
  }

  yield put({
    type: organizationTypes.SUBSCRIPTION_CODE_REVIEW_SUCCESS,
  });
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
  yield fetchBillingInfo({ organizationUUID: organizationUUID });
  yield put(
    generators.pullRequests.toggleReview.request({
      uuid: pullRequestUUID,
      enabled,
    })
  );
}
